// removed by extract-text-webpack-plugin
module.exports = {"icheckbox_square-blue":"icheckbox_square-blue","iradio_square-blue":"iradio_square-blue","hover":"hover","checked":"checked","disabled":"disabled"};


//////////////////
// WEBPACK FOOTER
// ./assets/styles/icheck/square/blue.css
// module id = ./assets/styles/icheck/square/blue.css
// module chunks = 1